import { render } from "./cargo-dispute.vue?vue&type=template&id=af0b16ac&scoped=true&ts=true"
import script from "./cargo-dispute.vue?vue&type=script&lang=ts"
export * from "./cargo-dispute.vue?vue&type=script&lang=ts"

import "./cargo-dispute.vue?vue&type=style&index=0&id=af0b16ac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af0b16ac"]])

export default __exports__